import { Injectable } from '@angular/core';
import { Tabs } from '../../modules/crm/crm-parent/crm-parent.component';
import { StructCapTabs } from '../../modules/crm/struct-cap-crm/struct-cap-crm-parent/struct-cap-crm-parent.component';
import { BaseCRMItem } from '../../shared/models/crm/CRMItem.model';
import { EmailLeaderModalComponent } from '../../modules/crm/crm-table/email-leader-modal/email-leader-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BannerNotificationsService, SpinnerService } from '../../xform-compat';
import { AuthenticationService } from './authentication.service';
import { BaseCrmService } from '../data-services/base-crm.service';

@Injectable({
  providedIn: 'root'
})
export class CrmIntegrationService {

  private _activeTab: Tabs | StructCapTabs;
  private _isClean: () => boolean;

  constructor(
    private modalService: NgbModal,
    private spinnerService: SpinnerService,
    private authenticationService: AuthenticationService,
    private baseCrmService: BaseCrmService,
    private bannerNotificationService: BannerNotificationsService,
  ) { }

  public sendLeaderEmail(item: BaseCRMItem) {
    const modalRef = this.modalService.open(EmailLeaderModalComponent, {
      size: 'lg',
      centered: true,
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.crmItem = item;

    modalRef.result.then(data => {
      if (data && data.subject && data.body) {
        this.spinnerService.start();
        const emailBody = `${this.authenticationService.getLoggedUser().fullName} says: ${data.body}`;
        this.baseCrmService.emailLeader(item.id, data.subject, emailBody).subscribe(
          () => {
            this.spinnerService.stop();
            this.bannerNotificationService.success('Email sent successfully to leader');
          },
          (error) => {
            this.spinnerService.stop();
            this.bannerNotificationService.error('Failed to send email: ' + (error.message || 'Unknown error'));
          }
        );
      }
    }).catch(() => {
      // Modal was dismissed, do nothing
    });
  }

  get activeTab(): Tabs | StructCapTabs {
    return this._activeTab;
  }

  set activeTab(value: Tabs | StructCapTabs) {
    this._activeTab = value;
  }

  get isClean(): () => boolean {
    return this._isClean;
  }

  set isClean(value: () => boolean) {
    this._isClean = value;
  }
}
